<form [formGroup]="savingProductDetailsForm">
  <div class="layout-row-wrap gap-2px responsive-column">
    <mat-form-field class="flex-48">
      <mat-label>{{ 'labels.inputs.Product Name' | translate }}</mat-label>
      <input
        matInput
        formControlName="name"
        matTooltip="{{ 'tooltips.A unique identifier for the saving product' | translate }}"
        required
      />
      <mat-error>
        {{ 'labels.inputs.Product Name' | translate }} {{ 'labels.commons.is' | translate }}
        <strong>{{ 'labels.commons.required' | translate }}</strong>
      </mat-error>
    </mat-form-field>

    <mat-form-field class="flex-48">
      <mat-label>{{ 'labels.inputs.Short Name' | translate }}</mat-label>
      <input
        matInput
        formControlName="shortName"
        matTooltip="{{ 'tooltips.A unique identifier for the saving product' | translate }}"
        maxlength="4"
        required
      />
      <mat-error>
        {{ 'labels.inputs.Short Name' | translate }} {{ 'labels.commons.is' | translate }}
        <strong>{{ 'labels.commons.required' | translate }}</strong>
      </mat-error>
    </mat-form-field>

    <mat-form-field class="flex-98">
      <mat-label>{{ 'labels.inputs.Description' | translate }}</mat-label>
      <textarea
        matInput
        matTooltip="{{ 'tooltips.Provides additional information' | translate }}"
        formControlName="description"
        cdkTextareaAutosize
        cdkAutosizeMinRows="2"
      ></textarea>
    </mat-form-field>
  </div>

  <div class="layout-row align-center gap-2percent margin-t responsive-column">
    <button mat-raised-button matStepperPrevious disabled>
      <fa-icon icon="arrow-left" class="m-r-10"></fa-icon>
      {{ 'labels.buttons.Previous' | translate }}
    </button>
    <button mat-raised-button matStepperNext>
      {{ 'labels.buttons.Next' | translate }}
      <fa-icon icon="arrow-right" class="m-l-10"></fa-icon>
    </button>
  </div>
</form>
